import { createUseStyles } from 'react-jss';

const styles = {
  formContent: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '4.2rem',
    gap: '3rem',
  },
  actionButton: {
    textTransform: 'uppercase',
    padding: 0,
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
